import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
// import Textarea from '../../../../Core/Fields/Floating/Textarea';

import RichTextEditor from '../../../../Core/TextEditor/RichtextEditor';
const Tab4 = ({
    setPrimaryadd, primaryadd, addaresslist, customerName,
    contactlist, primarycontact, setPrimarycontact

}) => {
    const [isGroup, setIsGroup] = useState(0)
    const status = 'no'


    return (
        <div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Primary Address and Contact </p>
                </div>

                <div className="d-flex" style={{ gap: '3rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Textarea
                                id="BrandDescription"
                                label="Primary Address"
                                style={{ whiteSpace: 'pre-wrap', backgroundColor: '#f8f6f6', width: '655px' }}
                                value={primaryadd}
                                readOnly
                                onChange={(val) => setPrimaryadd(val)}
                            />
                            {/* <RichTextEditor  content={primaryadd}   /> */}

                        </div>
                        <div className='mx-3' style={{ fontSize: '10px', color: '#00000099' }}>
                            <p>Reselect, if the chosen address is edited after save</p>
                        </div>

                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Customer Primary Contact"
                                value={primarycontact}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                        <div className='mx-3' style={{ fontSize: '10px', color: '#00000099' }}>
                            <p>Reselect, if the chosen address is edited after save</p>
                        </div>
                    </div>


                </div>

            </div>

            <div className="">
                <ActivityCard doctype="Customer" docname={customerName} />
            </div>

        </div>

    )
}

export default Tab4